(function() {
  angular.module('examManagement').controller('ExamTabsCtrl', ['$scope', 'TabSelection', function ($scope, TabSelection) {
    $scope.setSelectedTab = function(tabIndex) {
      TabSelection.set(tabIndex);
    };
  }]);
}).call(this);
